<div class="maintenance-container">
  <div class="maintenance-content">
    <!-- Logo -->
    <div class="logo-section">
      <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo" class="maintenance-logo" />
    </div>

    <!-- Icono de mantenimiento -->
    <div class="maintenance-icon">
      <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
          d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    </div>

    <!-- Mensaje principal -->
    <h1 class="maintenance-title">Sitio en Mantenimiento</h1>
    <p class="maintenance-message">
      Estamos realizando trabajos de mantenimiento para mejorar tu experiencia.
      <br />
      Volveremos pronto. Gracias por tu paciencia.
    </p>

    <!-- Información de contacto -->
    <div class="contact-info" *ngIf="contactEmail || contactPhone">
      <p class="contact-label">Si necesitas ayuda, contáctanos:</p>
      <div class="contact-details">
        <a *ngIf="contactEmail" [href]="'mailto:' + contactEmail" class="contact-link">
          <svg xmlns="http://www.w3.org/2000/svg" class="contact-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          {{ contactEmail }}
        </a>
        <a *ngIf="contactPhone" [href]="'tel:' + contactPhone" class="contact-link">
          <svg xmlns="http://www.w3.org/2000/svg" class="contact-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          {{ contactPhone }}
        </a>
      </div>
    </div>
  </div>
</div>
